export const countries =
  {
    'US' : 'United States',
    'CA' : 'Canada'
  };